@if (timeTypeControl && !customOnly) {
  <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
    <mat-label class="text-sm font-light">{{ label }}</mat-label>
    <mat-select [formControl]="timeTypeControl">
      @for (option of resolvedTimeTypeOptions; track option.value) {
        <mat-option [value]="option.value">{{ option.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
@if (customTimeForm && timeTypeControl && timeTypeControl.value === 'CUSTOM') {
  <form
    [formGroup]="customTimeForm"
    [class]="formCustomClass ? formCustomClass : 'flex flex-col  w-full'"
  >
    <fleet-date-with-time-control
      [minDate]="minDate"
      [defaultTime]="defaultStartTime"
      #startDate
      formControlName="fromDate"
      [dateLabel]="effectiveFromLabel ? effectiveFromLabel : 'Effective from'"
      [timeLabel]="'&nbsp;'"
      [labelClass]="inSearchForm ? 'text-sm font-light' : ''"
      [required]="fromRequired"
      [futureDateOnly]="minDate ? true : false"
      [controlCustomClass]="controlCustomClass"
      [includeTime]="includeTime"
      class="w-full mt-4"
    >
    </fleet-date-with-time-control>
    <fleet-date-with-time-control
      [ngClass]="formCustomClass ? '' : 'mt-4'"
      [minDate]="minDate"
      [defaultTime]="defaultEndTime"
      [required]="toRequired"
      #endDate
      formControlName="toDate"
      [dateLabel]="effectiveToLabel ? effectiveToLabel : 'Effective to'"
      [timeLabel]="'&nbsp;'"
      [labelClass]="inSearchForm ? 'text-sm font-light' : ''"
      [futureDateOnly]="minDate ? true : false"
      [controlCustomClass]="controlCustomClass"
      [includeTime]="includeTime"
      class="w-full"
    >
    </fleet-date-with-time-control>
    @if (!hideTimezone) {
      <mat-form-field class="w-full mt-3">
        <mat-label [class]="inSearchForm ? 'text-sm font-light' : ''"
          >Timezone</mat-label
        >
        <mat-select [formControl]="avaiableTimezoneControl">
          @for (zone of timezones; track zone) {
            <mat-option [value]="zone">{{ zone }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </form>
}
